var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropertyIconHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(289 773)",
    fill: "red"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-289 -773)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.715,2.508a2.245,2.245,0,0,0-1.391.481h0l-5.1,4.018A3.216,3.216,0,0,0,3,9.531v7.753a1.51,1.51,0,0,0,1.5,1.5h12.43a1.51,1.51,0,0,0,1.5-1.5V9.531a3.216,3.216,0,0,0-1.226-2.525l-.06-.049V3.573A.643.643,0,0,0,16.5,2.93H14.359a.643.643,0,0,0-.643.643v.683L12.107,2.988A2.245,2.245,0,0,0,10.715,2.508Zm0,1.283a.962.962,0,0,1,.6.208l2.65,2.087A.643.643,0,0,0,15,5.581V4.216h.857V7.27a.643.643,0,0,0,.245.5l.306.241a1.927,1.927,0,0,1,.735,1.515v7.753a.2.2,0,0,1-.214.214H4.5a.2.2,0,0,1-.214-.214V9.531a1.927,1.927,0,0,1,.735-1.515L10.119,4A.962.962,0,0,1,10.715,3.79ZM6.643,10.64A.643.643,0,0,0,6,11.283v3.429a.643.643,0,0,0,.643.643H9.215a.643.643,0,0,0,.643-.643V11.283a.643.643,0,0,0-.643-.643Zm5.572,0a.643.643,0,0,0-.643.643v3.429a.643.643,0,0,0,.643.643h2.572a.643.643,0,0,0,.643-.643V11.283a.643.643,0,0,0-.643-.643ZM7.286,11.926H8.572v2.143H7.286Zm5.572,0h1.286v2.143H12.859Z",
    transform: "translate(288.285 772.354)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyIconHouse);
export default __webpack_public_path__ + "static/media/property-icon-house.7fffd3f853bf53558ddaa3a86e82171b.svg";
export { ForwardRef as ReactComponent };